module.exports = __webpack_public_path__ + "static/media/home-image-3.df978b3a.jpg";